// Test configuration
export const START_TEST_CONFIG = 'START_TEST_CONFIG';
export const START_TEST_ID_TIMER = 'START_TEST_ID_TIMER';
export const RESET_TEST_CONFIG = 'RESET_TEST_CONFIG';
export const TEST_DURATION = '20:00';
export const TEST_MAX_ERRORS_STUDENT = 5;
export const TEST_MAX_ERRORS_DEVELOPER = 3;

// Test results
export const DISPATCH_TEST_RESULT = 'DISPATCH_TEST_RESULT';
export const DISPATCH_RESET_RESULT = 'DISPATCH_RESET_RESULT';

// Test selection
export const CHOICE_TEST = 'CHOICE_TEST';
export const REMOVE_TEST = 'REMOVE_TEST';
